import { render, staticRenderFns } from "./GlobalSearchCard.vue?vue&type=template&id=6f11604c&"
import script from "./GlobalSearchCard.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports